import {
  createProgressiveRequestHandler,
  createRequestHandler,
} from "../utils/requestHandlers";

import { MediaBaseRouteDelete } from "./media";
import { cfAPI } from "../api";
import { createFormData } from "../utils/onCreateFormData";
import { createProgressHandler } from "../utils/createProgressHandler"; // Assuming this utility exists

// Assuming this utility exists
// Action Types
const GALLERY_REQUEST = "GALLERY_REQUEST";
const GALLERY_ERROR = "GALLERY_ERROR";
const GALLERIES_FETCH = "GALLERIES_FETCH";
const GALLERY_FETCH = "GALLERY_FETCH";
const GALLERY_CREATE = "GALLERY_CREATE";
const GALLERY_EDIT = "GALLERY_EDIT";
const GALLERY_DELETE = "GALLERY_DELETE";
const GALLERY_DELETE_IMAGE = "GALLERY_DELETE_IMAGE";

// Download Action Types for galleries
const GALLERY_DOWNLOAD_START = "GALLERY_DOWNLOAD_START";
const GALLERY_DOWNLOAD_UPDATE = "GALLERY_DOWNLOAD_UPDATE";
const GALLERY_DOWNLOAD_FINISH = "GALLERY_DOWNLOAD_FINISH";

const BaseRoute = "cfwebapi/api/v1/galleries";

const INITIAL_STATE = {
  loading: false,
  galleries: [],
  gallery: {},
  error: "",
  downloadProgress: 0,
  isDownloading: false,
};

// Reusable action types object for consistency
const actionTypes = {
  fetch: {
    request: GALLERY_REQUEST,
    success: GALLERIES_FETCH,
    error: GALLERY_ERROR,
  },
  fetchSingle: {
    request: GALLERY_REQUEST,
    success: GALLERY_FETCH,
    error: GALLERY_ERROR,
  },
  create: {
    request: GALLERY_REQUEST,
    success: GALLERY_CREATE,
    error: GALLERY_ERROR,
  },
  update: {
    request: GALLERY_REQUEST,
    success: GALLERY_EDIT,
    error: GALLERY_ERROR,
  },
  delete: {
    request: GALLERY_REQUEST,
    success: GALLERY_DELETE,
    error: GALLERY_ERROR,
  },
  deleteImage: {
    request: GALLERY_REQUEST,
    success: GALLERY_DELETE_IMAGE,
    error: GALLERY_ERROR,
  },
  download: {
    request: GALLERY_REQUEST,
    start: GALLERY_DOWNLOAD_START,
    update: GALLERY_DOWNLOAD_UPDATE,
    finish: GALLERY_DOWNLOAD_FINISH,
    success: GALLERIES_FETCH,
    error: GALLERY_ERROR,
  },
};

// Actions using the new handlers
export const CreateGallery = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.post(BaseRoute, createFormData(values)),
    actionTypes.create,
    "Gallery Created"
  );
};

export const FetchGalleries = () => async (dispatch) => {
  await createProgressiveRequestHandler(
    dispatch,
    () =>
      cfAPI.get(BaseRoute, {
        onDownloadProgress: createProgressHandler(
          dispatch,
          actionTypes.download.update,
          actionTypes.download.finish
        ),
      }),
    actionTypes.download,
    createProgressHandler
  );
};

export const FetchGallery = (id) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.get(`${BaseRoute}/${id}`),
    actionTypes.fetchSingle,
    null // No toast message for a fetch
  );
};

export const UpdateGallery = (id, values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.patch(`${BaseRoute}/${id}`, createFormData(values)),
    actionTypes.update,
    "Gallery Updated"
  );
};

export const DeleteGalleryPicture = (name, fileName) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(MediaBaseRouteDelete(name, fileName)),
    actionTypes.deleteImage,
    "Image Deleted"
  );
};

export const DeleteGallery = (values) => async (dispatch) => {
  await createRequestHandler(
    dispatch,
    () => cfAPI.delete(`${BaseRoute}/${values.id}`),
    actionTypes.delete,
    "Gallery Deleted!"
  );
};

// Reducer with toasts removed and state logic updated
export const GalleryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Download Cases
    case GALLERY_DOWNLOAD_START:
      return { ...state, isDownloading: true, downloadProgress: 0 };
    case GALLERY_DOWNLOAD_UPDATE:
      return { ...state, downloadProgress: action.payload };
    case GALLERY_DOWNLOAD_FINISH:
      return { ...state, isDownloading: false, downloadProgress: 100 };

    // Request/Error Cases
    case GALLERY_REQUEST:
      return { ...state, loading: true };
    case GALLERY_ERROR:
      return { ...state, loading: false, error: action.payload };

    // Success Cases
    case GALLERIES_FETCH:
      return { ...state, loading: false, error: "", galleries: action.payload };
    case GALLERY_FETCH:
      return { ...state, loading: false, error: "", gallery: action.payload };
    case GALLERY_CREATE:
      return {
        ...state,
        loading: false,
        error: "",
        galleries: [...state.galleries, action.payload],
      };
    case GALLERY_EDIT:
      const updatedList = state.galleries.map((gal) =>
        gal.id === action.payload.id ? action.payload : gal
      );
      return {
        ...state,
        loading: false,
        error: "",
        gallery: action.payload,
        galleries: updatedList,
      };
    case GALLERY_DELETE:
      const filteredList = state.galleries.filter(
        (gal) => gal.id !== action.payload.id
      );
      return {
        ...state,
        loading: false,
        error: "",
        galleries: filteredList,
      };
    case GALLERY_DELETE_IMAGE:
      return {
        ...state,
        loading: false,
        error: "",
        gallery: action.payload,
      };
    default:
      return state;
  }
};
